import wx from 'weixin-js-sdk'
// import shareLogo from '../assets/images/shareLogo.png'
import crypto from 'crypto'
import { MD5 } from 'crypto-js'
import { getWxConfig } from '@/api'

const paramsStr = window.location.href?.split('?')[1] || ''
const seLink = window.location.host.includes('tmi')
  ? `https://tmi3.jzsec.com/third-open-accounts/login.html`
  : `https://mi.jzsec.com/third-open-accounts/login.html`
const shareLink = window.location.host.includes('tmi')
  ? `https://tmi3.jzsec.com/third-open-accounts/login.html#/?` + paramsStr.replace('#/', '')
  : `https://mi.jzsec.com/third-open-accounts/login.html#/?` + paramsStr.replace('#/', '')
const shareLogo =
  'data:image/png;base64,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'
const selfConfig = {
  appid: 'wxca3dc6906a1f3c48', // 无用
  // wx625e36eeeddde041
  // wxca3dc6906a1f3c48
  secret: 'a67ebddb34d4e8c4c2da221c19212b13', // 无用
  seLink: seLink, //生成签名的link
  shareLink: shareLink, //分享朋友/朋友圈的link
  jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'], // 服务端返回，未使用
  title: '华源证券邀您极速开户',
  desc: '7x24小时在线开户，多重权益等你来领，炒股理财就选华源证券',
  appIcon: shareLogo,
  lineIcon: shareLogo,
}
export function isWechatEnvironment() {
  const ua = navigator.userAgent.toLowerCase()
  return /micromessenger/.test(ua)
}
export async function testWx() {
  console.log('location', window.location.href.substring(0, window.location.href.indexOf('#')))
  const param: any = {
    appType: '1',
    deviceCode: '1',
    url: encodeURI(selfConfig.seLink),
  }
  param.dataAuth = getMd5(param)
  const res: any = await getWxConfig(param)
  console.log(111, res)
  if (res.code === 0) {
    const c: any = { ...res.data }
    c.jsApiList = [...c.jsApiList, 'updateAppMessageShareData', 'updateTimelineShareData']
    const config = {
      ...c,
    }
    // config.debug = true
    wx.config(config)
    wx.ready(function () {
      //需在用户可能点击分享按钮前就先调用
      const appConfig = {
        title: selfConfig.title, // 分享标题
        desc: selfConfig.desc, // 分享描述
        link: selfConfig.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: selfConfig.appIcon, // 分享图标
        success: function () {
          // 设置成功
        },
        fail: function (err: any) {
          console.log(err)
        },
      }
      const timeConfig = {
        title: selfConfig.title, // 分享标题
        desc: selfConfig.desc, // 分享描述
        link: selfConfig.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: selfConfig.appIcon, // 分享图标
        success: function () {
          // 设置成功
        },
        fail: function (err: any) {
          console.log(err)
        },
      }
      // 兼容就版本
      if (wx.updateAppMessageShareData) {
        wx.updateAppMessageShareData({ ...appConfig })
      } else {
        wx.onMenuShareAppMessage({ ...appConfig })
      }
      // 兼容就版本
      if (wx.updateTimelineShareData) {
        wx.updateTimelineShareData({ ...timeConfig })
      } else {
        wx.onMenuShareTimeline({ ...timeConfig })
      }
    })
  }
}

function generateSignature(url: string, accessToken: string, jsapiTicket: string) {
  // 构建签名参数
  const noncestr = createRandomString()
  const timestamp = Math.floor(Date.now() / 1000).toString()
  // 对所有参数进行字典序排序
  const rawString = `jsapi_ticket=${jsapiTicket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${url}`
  // 对参数拼接后的字符串进行 SHA-1 签名
  const sha1 = crypto.createHash('sha1')
  const signature = sha1.update(rawString).digest('hex')

  return {
    appId: selfConfig.appid,
    timestamp,
    nonceStr: noncestr,
    signature,
  }
}

// 生成随机字符串
function createRandomString() {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let randomString = ''
  for (let i = 0; i < 16; i++) {
    randomString += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return randomString
}

function getMd5(md5param: any) {
  const qs = objectToQueryString(md5param) + 'e2b9903d13c7e28458614cacd8c9a10b'
  return MD5(qs).toString()
}

/**
 * 转化对象到qs
 * */
function objectToQueryString(obj: any) {
  if (!obj || typeof obj !== 'object') {
    return ''
  }

  const arr: string[] = []
  Object.keys(obj).forEach(key => {
    const val = obj[key]
    arr.push(`${key}=${val}`)
  })
  return arr.length ? `${arr.join('')}` : ''
}
